import Auth from '../api/auth';
import { emitter } from 'shared/helpers/mitt';

// 402 module_required (módulo de produto não ativo): abre o paywall global
// (ModulePaywallModal) com CTA pra Assinatura — o erro segue rejeitado pro
// chamador tratar/ignorar.
const parseErrorCode = error => {
  const data = error?.response?.data;
  if (error?.response?.status === 402 && data?.code === 'module_required') {
    emitter.emit('showModulePaywall', { module: data.module });
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
